<template>
  <div class="container page">
    <AppToolbar
      :title="user ? user.firstName + ' ' + user.lastName : ''"
      :prev-route="
        item
          ? {
              name: 'OrganizationShow',
              params: { id: $iriToId(item.organization['@id']) }
            }
          : null
      "
    >
      <template slot="buttons"> </template>
    </AppToolbar>

    <div v-if="error" class="fill-height">
      <PageNotFound v-if="error === 'Not Found'" />
      <GenericError v-else />
    </div>
    <template v-else>
      <div v-if="isLoading || isLoadingUser" class="dialog-spinner">
        <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
      </div>
      <template v-else-if="user">
        <v-container>
          <v-row>
            <v-col class="text-center" cols="12" sm="4" md="3" lg="3" xl="3">
              <v-avatar size="128" class="mt-1">
                <img src="../../assets/no-img.svg" alt="" />
              </v-avatar>
            </v-col>
            <v-col cols="12" sm="8" md="9" lg="9" xl="9">
              <table class="table-alt">
                <tbody>
                  <tr>
                    <td class="text-uppercase"><strong>Username</strong></td>
                    <td>{{ user['username'] }}</td>
                  </tr>
                  <tr>
                    <td class="text-uppercase"><strong>Email</strong></td>
                    <td>{{ user['email'] }}</td>
                  </tr>
                  <!--
                <tr>
                  <td class="text-uppercase">Email Verified</td>
                  <td>{{ user['emailVerified'] }}</td>
                </tr>
                <tr>
                  <td class="text-uppercase">Enabled</td>
                  <td>{{ user['enabled'] }}</td>
                </tr>

                <tr>
                  <td>roleInVessels</td>
                  <td>{{ user['roleInVessels'] }}</td>
                </tr>
                <tr>
                  <td>roleInOrganizations</td>
                  <td>{{ user['roleInOrganizations'] }}</td>
                </tr>
                --></tbody>
              </table>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppToolbar from '@/components/AppToolbar'
import PageNotFound from '@/components/error/PageNotFound'
import GenericError from '@/components/error/GenericError'

export default {
  components: {
    PageNotFound,
    GenericError,
    AppToolbar
  },

  computed: mapGetters({
    error: 'roleinorganization/show/error',
    isLoading: 'roleinorganization/show/isLoading',
    item: 'roleinorganization/show/retrieved',
    errorUser: 'user/show/error',
    isLoadingUser: 'user/show/isLoading',
    user: 'user/show/retrieved'
  }),

  watch: {
    item: function(item) {
      if (!item) {
        return
      }

      this.retrieveUser(item.user['@id'])
    }
  },

  beforeDestroy() {
    this.reset()
    this.resetUser()
  },

  created() {
    this.retrieve('/role_in_organizations/' + this.$route.params.id)
  },

  methods: {
    ...mapActions({
      reset: 'roleinorganization/show/reset',
      retrieve: 'roleinorganization/show/retrieve',
      resetUser: 'user/show/reset',
      retrieveUser: 'user/show/retrieve'
    }),

    deleteItem(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'RoleInOrganizationList' }))
      }
    }
  }
}
</script>
